import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import { BaseMultiText } from '../../translation';

@Injectable({ providedIn: 'root' })
export class MetricService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    list(): Observable<BaseMultiText[]> {
        return this._http.get<BaseMultiText[]>(
            `${this._appConfig.API_ENDPOINTS.INSIGHT}/metrics`,
        );
    }
}
